const ONEPLUS_13T_MODEL_RE = /PKX110|OnePlus\s*13T|ONEPLUS\s*13T/i
const CAPABILITY_WAIT_MS = 320

export function isOnePlus13TCameraRuntime () {
  const ua = String((typeof navigator !== 'undefined' && navigator.userAgent) || '')
  return ONEPLUS_13T_MODEL_RE.test(ua)
}

export function waitForCameraCapabilities (ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, typeof ms === 'number' ? ms : CAPABILITY_WAIT_MS)
  })
}

export function readTrackCapabilities (track) {
  if (!track || typeof track.getCapabilities !== 'function') {
    return {}
  }
  try {
    return track.getCapabilities() || {}
  } catch (err) {
    return {}
  }
}

export function isLikelyMainBackCamera (caps) {
  return !!(caps && caps.torch && isEnvironmentFacing(caps))
}

export function pickOnePlus13TMainBackCamera (devices, currentDeviceId, currentCaps) {
  const currentScore = scoreOnePlus13TCapabilities(currentCaps, '')
  if (isLikelyMainBackCamera(currentCaps)) {
    return null
  }
  let best = null
  let bestScore = currentScore
  ;(devices || []).forEach((device) => {
    if (!device || !device.deviceId || device.deviceId === currentDeviceId) {
      return
    }
    if (isFrontLabel(device.label)) {
      return
    }
    const caps = readDeviceCapabilities(device)
    if (!caps || (!caps.torch && !caps.facingMode)) {
      return
    }
    const score = scoreOnePlus13TCapabilities(caps, device.label)
    if (score > bestScore) {
      bestScore = score
      best = device
    }
  })
  return best
}

export function listOnePlus13TBackProbeCandidates (devices, currentDeviceId) {
  return (devices || []).filter((device) => {
    if (!device || !device.deviceId || device.deviceId === currentDeviceId) {
      return false
    }
    if (isFrontLabel(device.label)) {
      return false
    }
    return isBackCameraDevice(device) || !device.label
  })
}

export function onePlus13TInitialZoom (capability) {
  if (!capability || !capability.supported) {
    return 1
  }
  if (capability.min < 1 && capability.max >= 1) {
    return 1
  }
  return capability.min
}

function readDeviceCapabilities (device) {
  if (!device || typeof device.getCapabilities !== 'function') {
    return null
  }
  try {
    return device.getCapabilities() || {}
  } catch (err) {
    return null
  }
}

function scoreOnePlus13TCapabilities (caps, label) {
  let score = 0
  if (caps && caps.torch) score += 6
  if (isEnvironmentFacing(caps)) score += 3
  if (caps && caps.focusMode && caps.focusMode.indexOf('continuous') >= 0) score += 2
  if (isFrontLabel(label)) score -= 10
  if (/tele/i.test(String(label || ''))) score -= 2
  return score
}

function isEnvironmentFacing (caps) {
  const modes = caps && caps.facingMode
  if (!modes) {
    return false
  }
  return (Array.isArray(modes) ? modes : [modes]).indexOf('environment') >= 0
}

function isFrontLabel (label) {
  return /front|user|前/i.test(String(label || ''))
}

function isBackCameraDevice (device) {
  if (!device || !device.deviceId) {
    return false
  }
  const label = String(device.label || '').toLowerCase()
  if (!label) {
    return false
  }
  return /back|rear|environment|后|背|wide|tele|camera2?\s*\d/.test(label) && !isFrontLabel(label)
}
